import { render } from "./detials.vue?vue&type=template&id=cb660884&scoped=true"
import script from "./detials.vue?vue&type=script&lang=js"
export * from "./detials.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./detials.vue?vue&type=style&index=1&id=cb660884&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb660884"]])

export default __exports__